import { NgModule } from '@angular/core';
import { AuthGuard } from '../../auth.guard';
import { Routes, RouterModule } from '@angular/router';
import { VaccineBatchesComponent } from './vaccine/vaccine-batches.component';
import { MedicalConditionCategoryComponent } from './medical-condition-category/medical-condition-category.component';
import { MedicalConditionComponent } from './medical-condition/medical-condition.component';
import { PrescriptionCategoryComponent } from './prescription-category/prescription-category.component';
import { RegionListComponent } from './regions/regions-list.component';
import { CountryListComponent } from './countries/countries-list.component';
import { DiseasesListComponent } from './diseases/diseases-list.component';
import { SupplierListComponent } from './suppliers/suppliers-list.component';
import { ProductCategoryListComponent } from './product-categories/product-categories-list.component';
import { PrescriptionComponent } from './presciption/prescription.component';
import { CountriesDiseasesListComponent } from './countries-diseases/countries-diseases-list.component';
import { LabTestDataComponent } from './lab-test-data/lab-test-data.component';
import { LabTestCategoryComponent } from './labtest-category/labtest-category.component';
import { DiseasesVaccinesListComponent } from './diseases-vaccines/diseases-vaccines-list.component';
import { MedicalConditionsVaccinesComponent } from './medical-conditions-vaccines/medical-conditions-vaccines-list.component';
import { ProductsListComponent } from './products/products-list.component';
import { EmailDomainComponent } from './email-domain/email-domain.component';
import { ConsultationsComponent } from './consultations/consultations.component';
import { CentreManagementFeesComponent } from './centre-management-fees/centre-management-fees.component';
import { ManageMemoMyTMBComponent } from './manage-memo-mytmb/manage-memo-mytmb.component';
//import { ClinicTypeListComponent } from './clinic-types/clinic-type-list.component';
//import { ReasonListComponent } from './reasons/reasons-list.component';
//import { ClinicsComponent } from './clinics/clinics.component';
//import { ClinicScheduleComponent } from './clinic-schedule/clinic-schedule.component';

const masterDataRoutes: Routes = [
  {
    path: '',
    canActivateChild: [AuthGuard],
    children: [
      { path: 'vaccines', component: VaccineBatchesComponent },
      { path: 'medical-categories', component: MedicalConditionCategoryComponent },
      { path: 'medical', component: MedicalConditionComponent },
      { path: 'presciption-categories', component: PrescriptionCategoryComponent },
      { path: 'regions', component: RegionListComponent },
      { path: 'countries', component: CountryListComponent },
      { path: 'diseases', component: DiseasesListComponent },
      { path: 'suppliers', component: SupplierListComponent },
      { path: 'product-categories', component: ProductCategoryListComponent },
      { path: 'presciption', component: PrescriptionComponent },
      { path: 'countries-diseases', component: CountriesDiseasesListComponent },
      { path: 'labtest-categories', component: LabTestCategoryComponent },
      { path: 'labtest', component: LabTestDataComponent },
      { path: 'diseases-vaccines', component: DiseasesVaccinesListComponent },
      { path: 'medical-conditions-vaccines', component: MedicalConditionsVaccinesComponent },
      { path: 'products', component: ProductsListComponent },
      { path: 'email-domains', component: EmailDomainComponent },
      { path: 'consultations', component: ConsultationsComponent },
      { path: 'centre-management-fees', component: CentreManagementFeesComponent },
      { path: 'manage-memo-mytmb', component: ManageMemoMyTMBComponent },
      // { path: 'clinic-type', component: ClinicTypeListComponent },
      // { path: 'reasons', component: ReasonListComponent },
      // { path: 'clinics', component: ClinicsComponent },
      // { path: 'clinic-schedule/:clinicId', component: ClinicScheduleComponent }
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(masterDataRoutes)
  ],
  exports: [
    RouterModule
  ],
  providers: []
})

export class MasterDataRoutingModule { }



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/master-data/master-data.routing.ts